export const NOT_UNIQUE = '3acc7587-06f6-4559-b388-c5f9a816e6d8';
export const BIOMETRY_EXPIRED = '709f3be1-0121-48fa-9cf8-ef51b8605ab1';
export const CODE_NOT_SENT = 'Code not found by given identity';
export const CODE_INCORRECT = 'Phone verification not passed';
export const UNKNOWN_ERROR_OTP_PROVIDER = 'Unknown error [failure] - OTP Provider';
export const INVALID_BANK = '3acc7587-06f6-4559-b388-c5f9a816e6d8';
export const INCORRECT_OLD_PASSWORD = 'c575f184-fd3f-4e39-ac29-6cd4d1c583a2';
export const INCORRECT_NEW_PASSWORD = 'c3cb4b83-5e23-4d29-aea8-d207604dc564';
export const NOT_VALID_IBAN_VALUE = 'b9401321-f9bf-4dcb-83c1-f31094440795';
export const USER_BLOCKED = 'User is blocked.';
export const SMS_CODE_VALIDATION_ERROR = 'validationError';
export const NOT_SAME_PHONE = 'Phone number is not same';
export const ALREADY_SENT_IN_LAST_MINUTE = '3f812f20-93db-4cca-b8e1-486583dd0c30';
export const DAY_LIMIT_GET_SMS = '7545bf56-4b01-4226-beb4-5d1a7af46888';
export const NOT_VALID_DOCUMENT_NUMBER = '959e701e-c6f4-486e-8a7f-21f9845ce3df';
export const EXPIRED_DATE_FIELD_VALIDATION_FAILED = '778b7ae0-84d3-481a-9dec-35fdb64b1d78';
export const INVALID_PHONE_FORMAT = 'fe0b2415-7cb1-43a1-a4b5-6fad41812329';
export const WALLET_IS_NOT_IDENTIFIED = '8b578400-c91d-4536-8f1f-c83edd95b07e';
export const WALLET_OWNER_IS_NOT_MATCHED = 'a591fdd6-2788-40d7-bb18-5dc67ed06864';
export const NOT_SAME_AS_CLIENT_PHONE = 'c627d31d-5946-4acb-b888-7dd0feffd8cc';
export const INVALID_RECAPTCHA_TOKEN = '66974369-db04-4bcd-a4fa-bee9ea8b92db';

export const ERROR_INSTANCE = {
  NOT_ALLOWED: 'NotAllowedError',
};
